import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {
  UserSubscription,
  UserSubscriptionCategory
} from "../../../../../../user/user-subscription";
import {OneMonthFreeStep} from "../../one-month-free.component";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";
import {FormControl} from "@angular/forms";
import {User} from "../../../../../../user/user";
import {Subscription} from "rxjs";
import {first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../../store";
import {ChosenPlan} from "../../../../payment-info/models/plan.model";
import {GoogleAnalyticsService} from "../../../../../services/google-analytics/google-analytics.service";
import {CookieService} from "ngx-cookie";

@Component({
    selector: 'db-one-month-free-demo',
    templateUrl: './one-month-free-demo.component.html',
    styleUrls: ['./one-month-free-demo.component.scss'],
    standalone: false
})
export class OneMonthFreeDemoComponent implements OnInit {

  @Input() currentSubscription: UserSubscription;
  @Input() user: User;
  @Input() step: number = 2;
  @Input() showAnnual?: boolean = false;
  @Input() showBackButton?: boolean;
  @Output() onPlanChange = new EventEmitter<ChosenPlan>();
  @Output() onStepChange = new EventEmitter<OneMonthFreeStep>();
  public periodSwitch: FormControl;
  public loading: boolean;
  public isMobile: boolean;
  public personalPlan: string[];
  public agencyPlan: string[];
  private _subscriptions: Subscription[];
  public monthlyPlans: boolean = true;
  public upgradeablePersonalSubscription: UserSubscription;
  public upgradeableEnterpriseSubscription: UserSubscription;
  public UserSubscriptionCategory = UserSubscriptionCategory;
  private _userHostingSubscriptions: UserSubscription[];
  private isNewPrice = false;


  constructor(
    private readonly activeModal: DbActiveModal,
    private readonly _googleAnalyticsService: GoogleAnalyticsService,
    private _store: Store<fromStore.DbStoreState>,
    private _cookieService: CookieService
  ) { }

  ngOnInit() {
    this.periodSwitch = new FormControl(this.showAnnual ? 12 : 1);
    this.activeModal.resize(600, 940);
    this.isMobile = window.innerWidth <= 991;
    this.personalPlan = [
      'Drag and drop website editor',
      '1 hosted website',
      'Connect a custom domain',
      'Add unlimited new pages with AI',
      '10GB SSD storage',
      'Website speed booster',
      'Premium Google Cloud hosting',
      'Website security, SSL certificate',
      'Search Engine Optimization (SEO)',
      '24/7 Live chat support'
    ];

    this.agencyPlan = [
      '10 hosted websites',
      '50GB SSD storage',
      'White label',
      'Multisite support',
      'User & team management',
      'VIP priority support'
    ];
    this.getAvailableSubscriptions();
    this.addEventHandlers();
  }

  private getAvailableSubscriptions(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        first(),
        switchMap(() => this._store.select(fromStore.getUserAvailableHostingSubscriptions())),
        first(res => !!res.length),
      )
      .subscribe(availableSubscriptions => {
        this._userHostingSubscriptions = availableSubscriptions;
        this.determineUpgradeSubscriptions();
      });
  }

  private determineUpgradeSubscriptions(): void {
    if (this.currentSubscription && [UserSubscriptionCategory.PERSONAL, UserSubscriptionCategory.PREMIUM, UserSubscriptionCategory.ENTERPRISE].includes(this.currentSubscription.category)) {
      this.upgradeablePersonalSubscription = null;
    }
    else {
      this.upgradeablePersonalSubscription = this._userHostingSubscriptions.find((userSubscription: UserSubscription): boolean => {
        return userSubscription && userSubscription.plan && userSubscription.category === UserSubscriptionCategory.PERSONAL && userSubscription.plan.periodNumber === this.periodSwitch.value && (this.isNewPrice ? userSubscription.isGeo : true);
      });
    }

    if (this.currentSubscription && this.currentSubscription.category !== UserSubscriptionCategory.NONE && [UserSubscriptionCategory.ENTERPRISE].includes(this.currentSubscription.category)) {
      this.upgradeableEnterpriseSubscription = null;
    }
    else {
      this.upgradeableEnterpriseSubscription = this._userHostingSubscriptions.find((userSubscription: UserSubscription): boolean => {
        return userSubscription && userSubscription.plan && userSubscription.category === UserSubscriptionCategory.ENTERPRISE && userSubscription && userSubscription.plan && userSubscription.plan.periodNumber === this.periodSwitch.value && (this.isNewPrice ? userSubscription.isGeo : true);
      });
    }
  }

  public changePlan(): void {
    this.monthlyPlans = !this.monthlyPlans;
    this.periodSwitch.setValue(!!this.monthlyPlans ? 1 : 12);
  }

  public chooseSubscr(subscription: UserSubscription) {
    const chosenPlan: ChosenPlan = {
      id: subscription.id,
      title: subscription.plan.title,
      price: subscription.plan.planPrice,
      type: this.periodSwitch.value === 12 ? 'year' : 'month'
    };
    this.onPlanChange.emit(chosenPlan);
    this._sendEvent(chosenPlan);
  }

  private _sendEvent(chosenPlan): void {
    const analyticsData = {
      eventCategory: 'Dashboard Pageview',
      eventAction: 'Checkout Page visit (1wf pop-up)',
      eventLabel: chosenPlan.title + ' ' + chosenPlan.type + 'ly'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  private addEventHandlers(): void {
    this._subscriptions = [];

    this._subscriptions.push(this.periodSwitch.valueChanges.subscribe((): void => {
      this.determineUpgradeSubscriptions();
    }));
  }
}
